import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/jjfa/caozuo.png'
import _imports_1 from '@/assets/images/solution/hudong.png'


const _hoisted_1 = { class: "industry" }
const _hoisted_2 = { class: "hytd-box" }
const _hoisted_3 = { class: "hytd" }
const _hoisted_4 = { class: "images" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fays" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "title" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "yycj" }
const _hoisted_15 = { class: "yycj-content" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "title" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "title" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "yyal" }
const _hoisted_23 = { class: "yyal-content" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "detail" }
const _hoisted_29 = { class: "pagination" }
const _hoisted_30 = ["onClick"]

import { ref, onMounted, computed } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
const pageSize = 5

export default /*@__PURE__*/_defineComponent({
  __name: 'IndustryModel',
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesListAll: any = ref([])
const currentPage = ref(1)
const prospects: any = ref(
  [
    {
      title: '互动性较弱',
      content: '传统培训模式互动性和参与感较弱，缺乏场景感，无法达到真实工作环境下的实操模拟培训及考核要求。',
      url: require('@/assets/images/solution/disadvantage1.png'),
      src: require('@/assets/images/solution/disadvantage-icon1.png')
    },
    {
      title: '数字化不足',
      content: '传统培训模式在实际操作过程中缺少量化参数及考核数据，无法形成企业组织培训数字化资产。',
      url: require('@/assets/images/solution/disadvantage2.png'),
      src: require('@/assets/images/solution/disadvantage-icon2.png')
    },
    {
      title: '培训成本高',
      content: '高危行业传统新员工操作培训成本高并带有安全风险，培训成本高，培训效率亟待提高。',
      url: require('@/assets/images/solution/disadvantage3.png'),
      src: require('@/assets/images/solution/disadvantage-icon3.png')
    }
  ]
)

const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

const totalPages = computed(() => Math.ceil(casesListAll.value.length / pageSize))
const paginatedCases = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return casesListAll.value.slice(start, start + pageSize)
})

const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++
}

const goToPage = (page: number) => {
  currentPage.value = page
}

onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为父组件被 keep-alive 缓存，子组件也会被缓存
  // 再次进入页面时 onMounted 仍会执行，但数据已经存在，不需要重新请求
  if (casesListAll.value.length === 0) {
    selectCommonElement({ columnId: 4 }).then((res: any) => {
      casesListAll.value = [...res].filter(e => e.industry == 2).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
      currentPage.value = 1
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.xiaolv) {
    const xiaolv: any = await asynchronousRetrieval('nfznxr-images/jjfa/xiaolv.png');
    const zichan: any = await asynchronousRetrieval('nfznxr-images/jjfa/zichan.png');
    const yycj_img3: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img3.png');
    const yycj_icon3: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon3.png');
    const yycj_icon4: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-icon4.png');
    const yycj_img4: any = await asynchronousRetrieval('nfznxr-images/jjfa/yycj-img4.png');
    const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
    loadUrl.value = { xiaolv, zichan, yycj_img3, yycj_icon3, yycj_icon4, yycj_img4, fays_bg }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title-font-style" }, "工业解决方案", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "illustrate" }, [
      _createElementVNode("div", null, "使用XR技术模拟复杂机械设备的装配、调试、维修维护等专业操作培训，提高员工培训效率，降低操作失误率，减少安全风险，为企业降本增效。")
    ], -1)),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "subtitle" }, "行业痛点", -1)),
    _cache[15] || (_cache[15] = _createElementVNode("div", null, [
      _createElementVNode("div", { class: "disadvantage" }, "伴随着工业领域的产业技术升级，数字化工厂的建设对企业传统培训做业流程提出新的挑战。工作流程复杂，设备操作复杂的特定行业需要高效的标准化的操作流程培训与考核。")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prospects.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: item.url
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.src
                }, null, 8, _hoisted_7),
                _createElementVNode("span", null, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("div", null, _toDisplayString(item.content), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "subtitle" }, "方案优势", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: loadUrl.value.fays_bg
      }, null, 8, _hoisted_9),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: loadUrl.value.xiaolv
            }, null, 8, _hoisted_11),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "培训效率提升", -1))
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, "XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。", -1))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
          _createElementVNode("div", { class: "title" }, [
            _createElementVNode("img", { src: _imports_0 }),
            _createElementVNode("span", null, "操作流程规范")
          ]),
          _createElementVNode("div", null, "AR标准化操作流程指导，配置可视化参数，规范员工作业过程，提升员工工作质量，从而提高企业效率。")
        ], -1))
      ]),
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("div", null, [
          _createElementVNode("div", { class: "title" }, [
            _createElementVNode("img", { src: _imports_1 }),
            _createElementVNode("span", null, "互动参与感强")
          ]),
          _createElementVNode("div", null, "基于实际环境、设备，以三维化多媒体素材为主，过程多样化智能交互，减少对传统纸质手册和专家的依赖，并结合具体情况提供更适合的情景培训。")
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              src: loadUrl.value.zichan
            }, null, 8, _hoisted_13),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "沉淀数字资产", -1))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", null, "培训过程中不断积累沉淀企业数字化内容，形成企业自有知识库。", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "subtitle" }, "应用场景", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img3,
            class: "left-radius"
          }, null, 8, _hoisted_16),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon3
              }, null, 8, _hoisted_18),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "新员工培训", -1))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "content" }, "模拟真实工作环境下的专项技能参数化模拟培训及考核。", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("img", {
                src: loadUrl.value.yycj_icon4,
                class: "right-radius"
              }, null, 8, _hoisted_20),
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "消防安全培训", -1))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "content" }, "对企业员工进行消防安全培训，增强消防安全意识，进一步提高消防安全素质和自防、自救能力。", -1))
          ]),
          _createElementVNode("img", {
            src: loadUrl.value.yycj_img4
          }, null, 8, _hoisted_21)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "subtitle" }, "应用案例", -1)),
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedCases.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (toOtherPath(`/case_detail?id=${item.id}&pathName=解决方案,工业解决方案,应用案例`, ['解决方案', '工业解决方案', '应用案例']))
          }, [
            _createElementVNode("img", {
              src: item.ossPath
            }, null, 8, _hoisted_25),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(item.title), 1),
              _createElementVNode("div", null, _toDisplayString(item.subTitle), 1),
              _createElementVNode("div", _hoisted_28, _toDisplayString(item.introduction), 1)
            ])
          ], 8, _hoisted_24))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", {
          class: "prev",
          onClick: prevPage
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (p) => {
          return (_openBlock(), _createElementBlock("div", {
            key: p,
            class: _normalizeClass(currentPage.value === p ? 'active' : ''),
            onClick: ($event: any) => (goToPage(p))
          }, _toDisplayString(p), 11, _hoisted_30))
        }), 128)),
        _createElementVNode("div", {
          class: "next",
          onClick: nextPage
        })
      ])
    ])
  ]))
}
}

})